module.exports = "/_next/static/images/ManageUserDeletion-5c6bf302bd9679d39c644532fc5705d0.webp";